import React from 'react'
import PropTypes from 'prop-types'

import { Text } from '@domain-group/suit-theme'

const Title = (props) => {
  const { children } = props

  return (
    <Text maxWidth="fit-content" variant="ellipsis">
      {children}
    </Text>
  )
}

Title.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Title
